const base = {
    get() {
        return {
            url : "http://localhost:8080/ssmvg6r7/",
            name: "ssmvg6r7",
            // 退出到首页链接
            indexUrl: 'http://localhost:8080/ssmvg6r7/front/index.html'
        };
    },
    getProjectName(){
        return {
            projectName: "劳务外包管理系统"
        } 
    }
}
export default base
